import { buildWhatsappLink } from "@/utils/whatsapp";

interface WhatsappButtonProps {
  numero: string | null | undefined;
  /** Libellé affiché — par défaut « Ouvrir WhatsApp ». */
  label?: string;
  className?: string;
}

/**
 * Bouton d'ouverture MANUELLE d'une conversation WhatsApp avec le numéro réel.
 * N'affiche rien si aucun numéro exploitable (jamais de faux lien).
 * Ce bouton ouvre simplement WhatsApp — il n'envoie AUCUN message automatique.
 */
export default function WhatsappButton({ numero, label = "Ouvrir WhatsApp", className }: WhatsappButtonProps) {
  const href = buildWhatsappLink(numero);
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={
        className ??
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-200 bg-background-50 px-4 py-2.5 text-sm font-label font-medium text-secondary-700 transition-colors hover:bg-secondary-50 cursor-pointer"
      }
    >
      <i className="ri-whatsapp-line text-base" aria-hidden="true" />
      {label}
    </a>
  );
}